import api from '@/api';
import Membership from '@/models/core/Membership';
import Context from '@/models/Context';
import Topic from '@/models/strategy/Topic';

const state = {
  isLoading: false,
  isUpdating: false,
  isDeleting: false,
  isFetched: false
};

const getters = {
  isLoading(state) {
    return state.isLoading;
  },

  isUpdating(state) {
    return state.isUpdating;
  },

  isDeleting(state) {
    return state.isDeleting;
  }
};

const mutations = {
  setLoading(state, value) {
    state.isLoading = value;
  },

  setUpdating(state, value) {
    state.isUpdating = value;
  },

  setDeleting(state, value) {
    state.isDeleting = value;
  },

  setFetched(state, value) {
    state.isFetched = value;
  }
};

const actions = {
  reset({ commit }) {
    commit('setLoading', false);
    commit('setUpdating', false);
    commit('setDeleting', false);
    commit('setFetched', false);
  },

  put({ commit }, value) {
    commit('setUpdating', true);

    const postData = Membership.query({
      where: membership => {
        return membership.id === value;
      }
    }).first();

    api.update(Membership, postData).then(() => {
      commit('setUpdating', false);
    });
  },

  findAll({ commit, dispatch }) {
    commit('setLoading', true);
    api
      .get('/memberships')
      .then(response => {
        dispatch(
          'normalize',
          { model: Membership, data: response.data.data },
          { root: true }
        );
      })
      .then(() => {
        commit('setLoading', false);
      });
  },

  findForTeam({ commit, dispatch, state }, forceUpdate = false) {
    if (!state.isFetched || forceUpdate) {
      const domain = Context.query().first().domain;

      commit('setLoading', true);
      api.get(`/${domain}/members`).then(response => {
        dispatch(
          'normalize',
          {
            model: Membership,
            data: response.data.data
          },
          { root: true }
        ).then(() => {
          commit('setLoading', false);
          commit('setFetched', true);
        });
      });
    }
  },

  remove({ commit }, collection) {
    return new Promise(resolve => {
      collection.forEach(member => {
        commit('setDeleting', true);
        api.remove(Membership, member).then(() => {
          Membership.delete(member.id);
          commit('setDeleting', false);
          resolve();
        });
      });
    });
  },

  update({ commit }, member) {
    return new Promise(resolve => {
      commit('setUpdating', true);
      api.update(Membership, member).then(() => {
        Membership.insertOrUpdate({ data: member });
        commit('setUpdating', false);
        resolve();
      });
    });
  },

  themes({ commit }, data) {
    return new Promise(resolve => {
      commit('setUpdating', true);

      data.values.removed.forEach(topicId => {
        const topic = Topic.query()
          .where(topic => {
            return topic.id === topicId;
          })
          .first();

        topic.members_collection.splice(
          topic.members_collection.indexOf(data.member.id),
          1
        );

        api.update(Topic, topic);
      });

      data.values.added.forEach(topicId => {
        const topic = Topic.query()
          .where(topic => {
            return topic.id === topicId;
          })
          .first();

        topic.members_collection.push(data.member.id);

        api.update(Topic, topic);
      });

      commit('setUpdating', false);
      resolve();
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
